/**
 * 会员权益
 */
import $goods from '@/api/modules/goods'
import { AsyncRequest } from '@/utils/request'

const state = {
  user: {}
}

const getters = {
  user: state => state.user
}

const mutations = {
  setUser: (state, obj) => {
    state.user = obj
  }
}

const actions = {
  // 激活用户
  activationActive({ commit }, payload) {
    return AsyncRequest({
      loading: true,
      request: () => $goods.activationActive(payload),
      resolve: res => {
        commit('setUser', res)
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
